<template>
	<div class="loader">
		<div v-for="i in 12" :class="[ 'circle' + i, 'loader-circle' ]"></div>
	</div>
</template>